/**
 * This file is auto-generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Works with versions ^2.0.8 of @itly/sdk and @itly/plugin's
 * https://www.npmjs.com/search?q=%40itly
 */

/* eslint-disable */

import { ItlyBrowser } from '@itly/sdk';
export { Loggers, Plugin, Validation } from '@itly/sdk';
import SchemaValidatorPlugin from '@itly/plugin-schema-validator';
import SegmentPlugin from '@itly/plugin-segment';

/**
 * @typedef {Object} AliasOptions
 * @property {Object} [segment]
 */

/**
 * @typedef {Object} IdentifyOptions
 * @property {Object} [segment]
 */

/**
 * @typedef {Object} GroupOptions
 * @property {Object} [segment]
 */

/**
 * @typedef {Object} PageOptions
 * @property {Object} [segment]
 */

/**
 * @typedef {Object} TrackOptions
 * @property {Object} [segment]
 */

class AiChatAction {
  constructor(properties) {
    this.name = 'ai_chat_action';
    this.id = '7ca6c0fb-99a0-40ac-90ca-2dce1d474dd4';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class AutonomousAgentAction {
  constructor(properties) {
    this.name = 'autonomous_agent_action';
    this.id = 'fbb88e39-fb84-4b23-88f7-98723d440045';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class CopilotAction {
  constructor(properties) {
    this.name = 'copilot_action';
    this.id = '5d6f4e74-dd65-4fb5-afa5-35cab5d0a9f7';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class CopilotNavigation {
  constructor(properties) {
    this.name = 'copilot_navigation';
    this.id = '20259a50-487c-418f-aa61-1e9911d9becf';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class DataSharingAction {
  constructor(properties) {
    this.name = 'data_sharing_action';
    this.id = '057615ac-fad9-4dda-b66c-3ce045100bdd';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class DealNavDrawerAction {
  constructor(properties) {
    this.name = 'deal_nav_drawer_action';
    this.id = 'a1d35b52-c67c-4456-bc27-bf6442237221';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class DealNavDrawerNavigation {
  constructor(properties) {
    this.name = 'deal_nav_drawer_navigation';
    this.id = '0c54b569-7498-4fb3-a17f-ec479ec62e5a';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class OptOutIsActive {
  constructor(properties) {
    this.name = 'opt_out_is_active';
    this.id = 'cc57dc0f-05a5-41d6-be3f-a956fbab414c';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class OrganizationActivated {
  constructor(properties) {
    this.name = 'organization_activated';
    this.id = '332e9b95-db6d-4cb7-9862-8b02b052d28b';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class PartnerWishlistAction {
  constructor(properties) {
    this.name = 'partner_wishlist_action';
    this.id = 'ce710aca-5d67-4e5f-9de2-216d53e5b345';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class PerformanceDashboardAction {
  constructor(properties) {
    this.name = 'performance_dashboard_action';
    this.id = 'e0ebf74d-032b-4f27-9f3d-a310b6f3f3a3';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class PerformanceDashboardNavigation {
  constructor(properties) {
    this.name = 'performance_dashboard_navigation';
    this.id = 'd2358e24-0542-45a5-860e-adcdbacb28f8';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserAcceptedPartnerInvite {
  constructor(properties) {
    this.name = 'user_accepted_partner_invite';
    this.id = '6dac1d42-a14d-4ffa-88ce-66f23c49f999';
    this.version = '4.0.0';
    this.properties = properties;
  }
}

class UserActsOnListColumns {
  constructor(properties) {
    this.name = 'user_acts_on_list_columns';
    this.id = '4b7643fe-6a9b-4ade-84b8-865e61d3df86';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserAddedMop {
  constructor(properties) {
    this.name = 'user_added_mop';
    this.id = '22c1749a-f817-4a20-b923-30fb6e1c2c67';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserAddsListNote {
  constructor(properties) {
    this.name = 'user_adds_list_note';
    this.id = '420e80ac-c0a1-437a-b233-e04f11a19725';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserAttributedPartners {
  constructor(properties) {
    this.name = 'user_attributed_partners';
    this.id = '383eb594-6605-4ff3-8f29-d956964307e6';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserChangesSharingRules {
  constructor(properties) {
    this.name = 'user_changes_sharing_rules';
    this.id = 'ff821b73-68ee-4d52-9df5-e4b51f3452e4';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClearedPartnerMappingManualMatch {
  constructor(properties) {
    this.name = 'user_cleared_partner_mapping_manual_match';
    this.id = '74cce477-a530-4a7c-aed4-3a64bd3c515b';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserClickedAddSeats {
  constructor(properties) {
    this.name = 'user_clicked_add_seats';
    this.id = '2f728e18-ab8c-4d98-bc03-dd98653afcd3';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedAttribution {
  constructor(properties) {
    this.name = 'user_clicked_attribution';
    this.id = '0ba88da7-0930-4cce-8a84-bc149008d857';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedCloseOutAction {
  constructor(properties) {
    this.name = 'user_clicked_close_out_action';
    this.id = 'b4d320f5-a722-41f6-b62f-9624e90bd439';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedConnectDataSource {
  constructor(properties) {
    this.name = 'user_clicked_connect_data_source';
    this.id = 'fe0cde35-70ac-4e30-b573-aaf64f760ffe';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClickedCreatePopulation {
  constructor(properties) {
    this.name = 'user_clicked_create_population';
    this.id = '60d7684a-d79c-406f-8c78-4a558a757054';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedCrmLink {
  constructor(properties) {
    this.name = 'user_clicked_crm_link';
    this.id = 'e46eac0e-69d5-4ba6-a8ad-56e694f7e6bf';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedDataSharingPreset {
  constructor(properties) {
    this.name = 'user_clicked_data_sharing_preset';
    this.id = '1b4969aa-3f52-4abd-8aec-2944f44d05f6';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedDowngrade {
  constructor(properties) {
    this.name = 'user_clicked_downgrade';
    this.id = 'a12fd7ff-b087-40a8-be83-f9973a94e8a2';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClickedEdit {
  constructor(properties) {
    this.name = 'user_clicked_edit';
    this.id = '30b3d518-8834-48cd-b8a8-f66355ef8542';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedFilters {
  constructor(properties) {
    this.name = 'user_clicked_filters';
    this.id = '171ac4cd-9b0f-4bb3-b3c6-3d31177758c1';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedIntegrationCta {
  constructor(properties) {
    this.name = 'user_clicked_integration_cta';
    this.id = '61f94a02-dbc7-4507-892f-c2a7fe0848ca';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserClickedKeepCurrentPlan {
  constructor(properties) {
    this.name = 'user_clicked_keep_current_plan';
    this.id = 'fc615557-d765-42ce-bb2c-1bbf1c433712';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedLearnMore {
  constructor(properties) {
    this.name = 'user_clicked_learn_more';
    this.id = '2985e9ab-045f-490a-9564-091729f35c18';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserClickedNotification {
  constructor(properties) {
    this.name = 'user_clicked_notification';
    this.id = '1b1f0c41-b345-46f4-b333-9a6355e57430';
    this.version = '5.0.0';
    this.properties = properties;
  }
}

class UserClickedPartnerDirectory {
  constructor(properties) {
    this.name = 'user_clicked_partner_directory';
    this.id = '1aeb4720-02f4-4d13-87a4-74b6f58b674b';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedPartnershipSummary {
  constructor(properties) {
    this.name = 'user_clicked_partnership_summary';
    this.id = '071c3bec-46fc-4639-b098-53feab7d1142';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClickedPayNow {
  constructor(properties) {
    this.name = 'user_clicked_pay_now';
    this.id = '9de62aff-dacd-4fa0-8103-0176c3c8168d';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedRequestAccess {
  constructor(properties) {
    this.name = 'user_clicked_request_access';
    this.id = '2dc39720-b042-453f-a00a-f66b8ef57577';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedRestorePlan {
  constructor(properties) {
    this.name = 'user_clicked_restore_plan';
    this.id = '21a69eaa-a336-47fc-adcb-7dfc32738f5e';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedReview {
  constructor(properties) {
    this.name = 'user_clicked_review';
    this.id = '739ad134-3537-4da0-8575-dcc4c6ada656';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedSeeOverlaps {
  constructor(properties) {
    this.name = 'user_clicked_see_overlaps';
    this.id = '3546e323-0620-4d42-8074-20e6a9b899aa';
    this.version = '6.0.0';
    this.properties = properties;
  }
}

class UserClickedSfApp {
  constructor(properties) {
    this.name = 'user_clicked_sf_app';
    this.id = 'fb9770fc-1f1b-4be0-bdbf-153b5b46d855';
    this.version = '4.0.0';
    this.properties = properties;
  }
}

class UserClickedSyncData {
  constructor(properties) {
    this.name = 'user_clicked_sync_data';
    this.id = 'd7db7ba0-5dd7-4530-a4e8-eacc683fb016';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClickedTalkToSalesSupernode {
  constructor(properties) {
    this.name = 'user_clicked_talk_to_sales_supernode';
    this.id = '90c3dc30-4019-4738-b227-96bb8acc0689';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClickedTopOverlaps {
  constructor(properties) {
    this.name = 'user_clicked_top_overlaps';
    this.id = '824fa43b-0d4d-4531-8a90-83ea48d7da95';
    this.version = '4.0.0';
    this.properties = properties;
  }
}

class UserClickedUniversalSuggestedPartner {
  constructor(properties) {
    this.name = 'user_clicked_universal_suggested_partner';
    this.id = 'faa328b9-fe49-43cd-b4f4-8a496daf1217';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClickedUpgradeConnector {
  constructor(properties) {
    this.name = 'user_clicked_upgrade_connector';
    this.id = '71aeceb1-22e1-48ed-a1fc-a596b125dde9';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserClickedUpgradePlatformConnector {
  constructor(properties) {
    this.name = 'user_clicked_upgrade_platform_connector';
    this.id = '023b352b-b031-4eab-86ba-159db1a79ff3';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserClicksAddOfflinePartner {
  constructor(properties) {
    this.name = 'user_clicks_add_offline_partner';
    this.id = '0b3b88b8-68db-478a-a1ad-2ee45ba1ba43';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClicksDealNavigator {
  constructor(properties) {
    this.name = 'user_clicks_deal_navigator';
    this.id = '4ff6c4a1-a5af-48da-a849-c18e8854c9b8';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserClicksGetIntelInCopilot {
  constructor(properties) {
    this.name = 'user_clicks_get_intel_in_copilot';
    this.id = '51bbc371-b3e2-4fc6-9c21-e772a0c0f366';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClicksPartnerstackReferLead {
  constructor(properties) {
    this.name = 'user_clicks_partnerstack_refer_lead';
    this.id = 'd7843b49-32c3-4f54-9c2c-271dd8d7bb21';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClicksPartnerstackSubmitLead {
  constructor(properties) {
    this.name = 'user_clicks_partnerstack_submit_lead';
    this.id = 'c1a01d22-6649-4f0f-abad-5737a9825a7f';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClicksSendRecords {
  constructor(properties) {
    this.name = 'user_clicks_send_records';
    this.id = '0e04840e-2a17-4d2b-8457-a17e1fffa988';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserClicksSetupGuide {
  constructor(properties) {
    this.name = 'user_clicks_setup_guide';
    this.id = '95a90900-156e-4f77-ab85-aa96d9494a2d';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserCompletesOnboarding {
  constructor(properties) {
    this.name = 'user_completes_onboarding';
    this.id = 'ce77a909-9937-4728-a988-10afa426842e';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserConnectedDataSource {
  constructor(properties) {
    this.name = 'user_connected_data_source';
    this.id = '98a51c4d-1db1-4797-8e06-b15dceeec039';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserCopiesDataInCopilot {
  constructor(properties) {
    this.name = 'user_copies_data_in_copilot';
    this.id = 'a9435b80-545d-4703-8f31-550fc444434a';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserCreatedList {
  constructor(properties) {
    this.name = 'user_created_list';
    this.id = '16436ae8-0d8a-4574-a7d1-8974927cb17b';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserCreatedPopulation {
  constructor(properties) {
    this.name = 'user_created_population';
    this.id = '0564c2db-64ae-4f27-9794-5d3e7be1bffd';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserCreatedReport {
  constructor(properties) {
    this.name = 'user_created_report';
    this.id = '92628673-5be2-43b6-87c4-fb9a5f72966c';
    this.version = '4.0.0';
    this.properties = properties;
  }
}

class UserDefinedDataSharing {
  constructor(properties) {
    this.name = 'user_defined_data_sharing';
    this.id = '09f8d7ba-ec1f-4472-8918-b63d28fe208a';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserDefinedSharingPreset {
  constructor(properties) {
    this.name = 'user_defined_sharing_preset';
    this.id = '9af7b786-19bf-4196-93f5-5d9e15811f6a';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserEditedList {
  constructor(properties) {
    this.name = 'user_edited_list';
    this.id = '1e253f99-05ae-44e7-b620-04570159e3d9';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserExportedAuditlog {
  constructor(properties) {
    this.name = 'user_exported_auditlog';
    this.id = '8dc155ed-f07c-47ea-8153-630533483af8';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserExportedReport {
  constructor(properties) {
    this.name = 'user_exported_report';
    this.id = '55848fd3-d08b-4e1f-98ff-130064780f3e';
    this.version = '8.0.0';
    this.properties = properties;
  }
}

class UserIgnoredSuggestedPartner {
  constructor(properties) {
    this.name = 'user_ignored_suggested_partner';
    this.id = '4e0cea68-ff07-4465-a6f7-27755f27b6ae';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserInteractedWithIrp {
  constructor(properties) {
    this.name = 'user_interacted_with_irp';
    this.id = '59c67e9a-2de6-4d88-bea8-b5d1b3407d11';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserInteractedWithTimeline {
  constructor(properties) {
    this.name = 'user_interacted_with_timeline';
    this.id = '51eb1768-6b7f-413f-b03c-f948b5f327e0';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserInvitesTeammate {
  constructor(properties) {
    this.name = 'user_invites_teammate';
    this.id = 'ea6d1075-42b9-41af-9bc7-ee4bf6c95902';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserLaunchedQuickAccountMapping {
  constructor(properties) {
    this.name = 'user_launched_quick_account_mapping';
    this.id = 'c14615d0-f50b-44ae-a8a4-4be52c9661c0';
    this.version = '4.0.0';
    this.properties = properties;
  }
}

class UserLoggedIn {
  constructor(properties) {
    this.name = 'user_logged_in';
    this.id = '98b406a5-7d14-41ea-a3fa-db979c554228';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserOpensSetupGuide {
  constructor(properties) {
    this.name = 'user_opens_setup_guide';
    this.id = '6526da20-bb6f-4c76-9534-1de43ccf61ad';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserRanReport {
  constructor(properties) {
    this.name = 'user_ran_report';
    this.id = '7a737e73-ffa0-4c5c-ae35-d343fc4c97eb';
    this.version = '7.0.0';
    this.properties = properties;
  }
}

class UserRedeemsInvite {
  constructor(properties) {
    this.name = 'user_redeems_invite';
    this.id = 'd313ed52-8b76-4dcb-838c-c8458de8bbdb';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserRegistrationElgSummit {
  constructor(properties) {
    this.name = 'user_registration_elg_summit';
    this.id = '2bab039e-3e83-4b6d-91c6-bbf007a7378a';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserRemovedPartnerMappingRule {
  constructor(properties) {
    this.name = 'user_removed_partner_mapping_rule';
    this.id = '9cffdca5-7400-44db-a1df-056c3730b416';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserRequestedAccessToBetaFeature {
  constructor(properties) {
    this.name = 'user_requested_access_to_beta_feature';
    this.id = '2f8f91c2-ce78-4085-bf6e-645f32906775';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserRequestedAgentTrigger {
  constructor(properties) {
    this.name = 'user_requested_agent_trigger';
    this.id = '8719ae63-c2c5-4920-b965-040f63e2eb5b';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserRequestedDataShare {
  constructor(properties) {
    this.name = 'user_requested_data_share';
    this.id = '822a4047-c433-4549-98a0-96c505fba646';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserRequestedFreeTrial {
  constructor(properties) {
    this.name = 'user_requested_free_trial';
    this.id = 'd567590b-9e9b-496f-b7e6-ece43b81e10d';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserRequestedFreeTrialContact {
  constructor(properties) {
    this.name = 'user_requested_free_trial_contact';
    this.id = 'ba81a212-a61f-4ff5-b05b-c0389e749d42';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserRequestedSeat {
  constructor(properties) {
    this.name = 'user_requested_seat';
    this.id = '58966706-6f3b-4bec-adbf-a96cc1cab1b8';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserReviewsBillingPlan {
  constructor(properties) {
    this.name = 'user_reviews_billing_plan';
    this.id = '2303bba1-7e5f-429b-b7dc-0aa48e60d44d';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserSavedPartnerMappingRule {
  constructor(properties) {
    this.name = 'user_saved_partner_mapping_rule';
    this.id = 'fb77f27e-d19f-43a7-bba2-8985e3e7cfac';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserSavesCopilotIntegrationSetting {
  constructor(properties) {
    this.name = 'user_saves_copilot_integration_setting';
    this.id = 'db65827f-15c5-4ed2-bf24-ae50bfac1a7d';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserSearches {
  constructor(properties) {
    this.name = 'user_searches';
    this.id = '42699547-c557-45b8-abaa-359c494c4b3f';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserSendsRecords {
  constructor(properties) {
    this.name = 'user_sends_records';
    this.id = '2b83d6ce-baec-49ae-9a89-49183274ce20';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserSentPartnerInvite {
  constructor(properties) {
    this.name = 'user_sent_partner_invite';
    this.id = '4c3c1a16-a3bc-48b4-b22b-de868a13221f';
    this.version = '3.0.0';
    this.properties = properties;
  }
}

class UserSetPartnerMappingManualMatch {
  constructor(properties) {
    this.name = 'user_set_partner_mapping_manual_match';
    this.id = '18921474-a551-4895-aa4e-d54bbee77fa9';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserSharesListAction {
  constructor(properties) {
    this.name = 'user_shares_list_action';
    this.id = '0c268638-306e-4e1f-a5c4-ed370b120f84';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserToggledPartnerTagsSync {
  constructor(properties) {
    this.name = 'user_toggled_partner_tags_sync';
    this.id = '4904b92a-9f9d-4b6f-88a6-87dce79f7ba2';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserUpdatedListRecords {
  constructor(properties) {
    this.name = 'user_updated_list_records';
    this.id = 'f05b902e-d01d-47d1-8721-b61e2b571e36';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserUpdatedSharedListAccess {
  constructor(properties) {
    this.name = 'user_updated_shared_list_access';
    this.id = 'ba46ea10-2b67-4049-9649-f1b3f995f4a8';
    this.version = '1.0.0';
    this.properties = properties;
  }
}

class UserUpgradesToConnector {
  constructor(properties) {
    this.name = 'user_upgrades_to_connector';
    this.id = '895f92d1-3b23-43ab-a17d-edf406852bf5';
    this.version = '2.0.0';
    this.properties = properties;
  }
}

class UserUpgradesToPlatformConnector {
  constructor(properties) {
    this.name = 'user_upgrades_to_platform_connector';
    this.id = 'd80cf5f2-5804-40f6-9d12-205337b5e01f';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

class UserViewedPartnerMappingTab {
  constructor(properties) {
    this.name = 'user_viewed_partner_mapping_tab';
    this.id = '45457376-f710-477c-9158-efbed6825373';
    this.version = '0.0.1';
    this.properties = properties;
  }
}

// prettier-ignore
class Itly {
  constructor() {
    this.itly = new ItlyBrowser();
  }

  /**
   * Initialize the Itly SDK. Call once when your application starts.
   * @param {Object} [loadOptions] Configuration options to initialize the Itly SDK with.
   */
  load(loadOptions) {
    loadOptions = loadOptions || {};
    const {
      destinations = {},
      plugins = [],
      ...options
    } = loadOptions;

    const destinationPlugins = destinations.all && destinations.all.disabled
      ? []
      : [
        new SegmentPlugin(options.environment === 'production'
          ? 'X1zCfmWRKNcJP8eGjOdB6bYowABE0pEE'
          : '1AnBkdLaTFe6w1L94NClYpUK8i5kpuFi',
          destinations.segment,
        ),
      ];

    this.itly.load({
      ...options,
      plugins: [
        new SchemaValidatorPlugin({
          'group': {"type":"object","properties":{"name":{"type":"string"}},"additionalProperties":false,"required":[]},
          'identify': {"type":"object","properties":{"email":{"type":"string"}},"additionalProperties":false,"required":["email"]},
          'ai_chat_action': {"type":"object","properties":{"conversation_id":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"source":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["conversation_id","email","organization_id","type","user_id"]},
          'autonomous_agent_action': {"type":"object","properties":{"action":{"type":"string"},"conditions":{"items":{"type":"string"},"type":"array"},"description":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"instructions":{"type":"string"},"notification_channel":{"items":{"type":"string"},"type":"array"},"notification_channel_type":{"type":"string"},"organization_id":{"type":"string"},"trigger":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["description","email","organization_id","trigger","user_id"]},
          'copilot_action': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"source":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","type"]},
          'copilot_navigation': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"source":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","type"]},
          'data_sharing_action': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'deal_nav_drawer_action': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","type"]},
          'deal_nav_drawer_navigation': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","type"]},
          'opt_out_is_active': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'organization_activated': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"triggering_event":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","triggering_event","user_id"]},
          'partner_wishlist_action': {"type":"object","properties":{"action":{"type":"string"},"contact_count":{"type":"integer"},"decline_reason":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"has_errors":{"type":"boolean"},"has_message":{"type":"boolean"},"invite_count":{"type":"integer"},"invite_option":{"type":"string"},"is_on_crossbeam":{"type":"boolean"},"metadata":{"type":"object"},"on_crossbeam_count":{"type":"integer"},"organization_id":{"type":"string"},"remove_count":{"type":"number"},"total_partners":{"type":"integer"},"total_rows":{"type":"integer"},"type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","event_site","organization_id","type","user_id"]},
          'performance_dashboard_action': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"iframe":{"type":"boolean"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","type"]},
          'performance_dashboard_navigation': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"iframe":{"type":"boolean"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","type"]},
          'user_accepted_partner_invite': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"invite_type":{"type":"string"},"organization_id":{"type":"string"},"partner_organization_id":{"type":"string"},"proposal_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_organization_id","proposal_id","user_id"]},
          'user_acts_on_list_columns': {"type":"object","properties":{"column_action":{"type":"string"},"column_name":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"new_value":{"type":"string"},"old_value":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["column_action","column_name","email","organization_id","user_id"]},
          'user_added_mop': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"mop":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","mop","organization_id","user_id"]},
          'user_adds_list_note': {"type":"object","properties":{"account_id":{"type":"string"},"content":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"report_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["account_id","email","organization_id","user_id"]},
          'user_attributed_partners': {"type":"object","properties":{"action":{"type":"string"},"attribution_method":{"type":"string"},"close_won_date":{"type":"string"},"deal_id":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"opportunity_account_name":{"type":"string"},"opportunity_amount":{"type":"number"},"opportunity_name":{"type":"string"},"opportunity_stage":{"type":"string"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["attribution_method","deal_id","email","opportunity_account_name","opportunity_name","organization_id","user_id"]},
          'user_changes_sharing_rules': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"new_field_ids_shared":{"items":{"type":"string"},"type":"array"},"organization_id":{"type":"string"},"partner_id":{"items":{"type":"string"},"type":"array"},"partner_population_id":{"items":{"type":"string"},"type":"array"},"population_id":{"type":"string"},"preset_type":{"type":"string"},"previous_field_ids_shared":{"items":{"type":"string"},"type":"array"},"previous_sharing_rule":{"type":"string"},"sharing_level":{"type":"string"},"sharing_rule":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","population_id","sharing_level","sharing_rule","user_id"]},
          'user_cleared_partner_mapping_manual_match': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"number"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"source_id":{"type":"number"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","feed_id","organization_id","source_id","user_id"]},
          'user_clicked_add_seats': {"type":"object","properties":{"cta":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"location":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","location","organization_id","user_id"]},
          'user_clicked_attribution': {"type":"object","properties":{"attribution_source":{"type":"string"},"close_won_date":{"type":"string"},"deal_id":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"opportunity_account_name":{"type":"string"},"opportunity_amount":{"type":"number"},"opportunity_name":{"type":"string"},"opportunity_stage":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["attribution_source","deal_id","email","opportunity_account_name","opportunity_name","organization_id","user_id"]},
          'user_clicked_close_out_action': {"type":"object","properties":{"close_out_location":{"type":"string"},"close_won_date":{"type":"string"},"deal_id":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feature_name":{"type":"string"},"is_dismissed":{"type":"boolean"},"opportunity_account_name":{"type":"string"},"opportunity_amount":{"type":"number"},"opportunity_name":{"type":"string"},"opportunity_stage":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["close_out_location","deal_id","email","feature_name","opportunity_account_name","opportunity_name","organization_id","user_id"]},
          'user_clicked_connect_data_source': {"type":"object","properties":{"data_source_type":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["data_source_type","email","organization_id","user_id"]},
          'user_clicked_create_population': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"population_type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_clicked_crm_link': {"type":"object","properties":{"close_won_date":{"type":"string"},"crm_type":{"type":"string"},"deal_id":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"opportunity_account_name":{"type":"string"},"opportunity_amount":{"type":"number"},"opportunity_name":{"type":"string"},"opportunity_stage":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["crm_type","deal_id","email","opportunity_account_name","opportunity_name","organization_id","user_id"]},
          'user_clicked_data_sharing_preset': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"preset_type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_clicked_downgrade': {"type":"object","properties":{"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_clicked_edit': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"property_name":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","property_name","user_id"]},
          'user_clicked_filters': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"end_date":{"type":"string"},"event_site":{"type":"string"},"filter_location":{"type":"string"},"filter_name":{"type":"string"},"max_amount_range":{"type":"number"},"metadata":{"type":"object"},"min_amount_range":{"type":"number"},"opportunity_stage":{"type":"string"},"organization_id":{"type":"string"},"start_date":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["email","filter_location","filter_name","organization_id","user_id"]},
          'user_clicked_integration_cta': {"type":"object","properties":{"button_name":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"integration_name":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["button_name","email","integration_name","organization_id","user_id"]},
          'user_clicked_keep_current_plan': {"type":"object","properties":{"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_clicked_learn_more': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_clicked_notification': {"type":"object","properties":{"cta":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"notification_text":{"type":"string"},"notification_unread":{"type":"boolean"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","notification_text","notification_unread","organization_id","user_id"]},
          'user_clicked_partner_directory': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_email":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_email","user_id"]},
          'user_clicked_partnership_summary': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"potential_revenue":{"type":"number"},"summary_type":{"type":"string"},"total_overlaps":{"type":"number"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","summary_type","user_id"]},
          'user_clicked_pay_now': {"type":"object","properties":{"billing_cycle":{"type":"string"},"cta":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"full_seats":{"type":"number"},"invoice_amount":{"type":"number"},"organization_id":{"type":"string"},"sales_seats":{"type":"number"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","full_seats","organization_id","sales_seats","user_id"]},
          'user_clicked_request_access': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"location":{"type":"string"},"organization_id":{"type":"string"},"user_email":{"type":"string"}},"additionalProperties":false,"required":["email","location","organization_id","user_email"]},
          'user_clicked_restore_plan': {"type":"object","properties":{"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_clicked_review': {"type":"object","properties":{"billing_cycle":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"invoice_amount":{"type":"number"},"number_of_seats":{"type":"number"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","number_of_seats","organization_id","user_id"]},
          'user_clicked_see_overlaps': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_id":{"type":"string"},"population_id":{"items":{"type":"number"},"type":"array"},"records_returned":{"type":"integer"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_id","population_id","user_id"]},
          'user_clicked_sf_app': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_email":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_email","user_id"]},
          'user_clicked_sync_data': {"type":"object","properties":{"cta_location":{"type":"string"},"data_type":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["data_type","email","organization_id","user_id"]},
          'user_clicked_talk_to_sales_supernode': {"type":"object","properties":{"attribution_credits":{"type":"string"},"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"early_adopter_status":{"type":"boolean"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_clicked_top_overlaps': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_id":{"type":"string"},"partner_population_id":{"type":"string"},"population_id":{"type":"string"},"records_returned":{"type":"integer"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_id","partner_population_id","population_id","user_id"]},
          'user_clicked_universal_suggested_partner': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_id":{"type":"string"},"partner_url":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_url","user_id"]},
          'user_clicked_upgrade_connector': {"type":"object","properties":{"billing_cycle":{"type":"string"},"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"early_adopter_status":{"type":"boolean"},"email":{"type":"string"},"event_site":{"type":"string"},"number_of_seats":{"type":"number"},"organization_id":{"type":"string"},"report_id":{"type":"string"},"report_name":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_clicked_upgrade_platform_connector': {"type":"object","properties":{"billing_cycle":{"type":"string"},"cta":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"has_discount":{"type":"boolean"},"number_of_seats":{"type":"number"},"organization_id":{"type":"string"},"report_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_clicks_add_offline_partner': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_clicks_deal_navigator': {"type":"object","properties":{"action_name":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_clicks_get_intel_in_copilot': {"type":"object","properties":{"email":{"type":"string"},"event_site":{"type":"string"},"object":{"type":"string"},"organization_id":{"type":"string"},"overlap_company_domain":{"type":"string"},"overlap_company_name":{"type":"string"},"source":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","user_id"]},
          'user_clicks_partnerstack_refer_lead': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"list_id":{"type":"string"},"organization_id":{"type":"string"},"refer_lead_location":{"type":"string"},"report_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","refer_lead_location","user_id"]},
          'user_clicks_partnerstack_submit_lead': {"type":"object","properties":{"company_name":{"type":"string"},"contact_email":{"type":"string"},"contact_first_name":{"type":"string"},"contact_last_name":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"list_id":{"type":"string"},"organization_id":{"type":"string"},"partnerstack_partner":{"type":"string"},"report_id":{"type":"string"},"submit_lead_location":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["company_name","contact_email","contact_first_name","contact_last_name","email","organization_id","partnerstack_partner","submit_lead_location","user_id"]},
          'user_clicks_send_records': {"type":"object","properties":{"action_name":{"type":"string"},"clicked_from":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"list_id":{"type":"string"},"list_name":{"type":"string"},"location":{"type":"string"},"number_of_records":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["action_name","clicked_from","email","list_name","location","number_of_records","organization_id","user_id"]},
          'user_clicks_setup_guide': {"type":"object","properties":{"button_name":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"setup_button_name":{"type":"string"},"setup_step_name":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","setup_button_name","setup_step_name","user_id"]},
          'user_completes_onboarding': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_connected_data_source': {"type":"object","properties":{"custom_presets":{"items":{"type":"string"},"type":"array"},"data_source_type":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"string"},"initial_sync_selection":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["data_source_type","email","feed_id","organization_id","user_id"]},
          'user_copies_data_in_copilot': {"type":"object","properties":{"action_type":{"type":"string"},"copied_data":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"email_type":{"type":"string"},"event_site":{"type":"string"},"object":{"type":"string"},"organization_id":{"type":"string"},"partner_names":{"items":{"type":"string"},"type":"array"},"source":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["copied_data","email","organization_id","partner_names","source","user_id"]},
          'user_created_list': {"type":"object","properties":{"collaborator_id":{"type":"number"},"collaborator_user_id":{"type":"number"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"list_description":{"type":"string"},"list_name":{"type":"string"},"location":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["collaborator_id","collaborator_user_id","email","list_description","list_name","location","organization_id","user_id"]},
          'user_created_population': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"population_id":{"type":"string"},"population_name":{"type":"string"},"population_type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","population_id","population_name","user_id"]},
          'user_created_report': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"greenfield_type":{"type":"string"},"organization_id":{"type":"string"},"partner_impact_scores":{"items":{"type":"string"},"type":"array"},"records_returned":{"type":"integer"},"report_id":{"type":"string"},"report_type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","report_type","user_id"]},
          'user_defined_data_sharing': {"type":"object","properties":{"bulk":{"type":"boolean"},"changed":{"items":{"type":"string"},"type":"array"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"partner_id":{"type":"string"},"partner_population_id":{"items":{"type":"string"},"type":"array"},"population_id":{"type":"string"},"population_type":{"type":"string"},"preset_type":{"type":"string"},"previous_sharing_level":{"type":"string"},"previous_visibility_level":{"type":"string"},"shared_fields":{"items":{"type":"string"},"type":"array"},"sharing_level":{"type":"string"},"source":{"type":"string"},"user_id":{"type":"string"},"visibility_level":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","population_id","sharing_level","source","user_id","visibility_level"]},
          'user_defined_sharing_preset': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"preset_type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_edited_list': {"type":"object","properties":{"action":{"type":"string"},"column_id":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"list_id":{"type":"string"},"new_value":{"type":"string"},"note_type":{"type":"string"},"organization_id":{"type":"string"},"previous_value":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","previous_value","user_id"]},
          'user_exported_auditlog': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"end_date":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"records_exported":{"type":"integer","minimum":0},"start_date":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_exported_report': {"type":"object","properties":{"default_column_names":{"items":{"type":"string"},"type":"array"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"greenfield_type":{"type":"string"},"location":{"type":"string"},"organization_id":{"type":"string"},"partner_id":{"items":{"type":"number"},"type":"array"},"partner_impact_scores":{"items":{"type":"string"},"type":"array"},"population_id":{"items":{"type":"number"},"type":"array"},"records_exported":{"type":"integer","minimum":0},"report_id":{"type":"string"},"report_name":{"type":"string"},"report_type":{"type":"string"},"source_field_ids":{"items":{"type":"string"},"type":"array"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","location","organization_id","partner_id","population_id","report_type","user_id"]},
          'user_ignored_suggested_partner': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_id":{"type":"string"},"partner_url":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_url","user_id"]},
          'user_interacted_with_irp': {"type":"object","properties":{"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"tab":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_interacted_with_timeline': {"type":"object","properties":{"cta":{"type":"string"},"cta_2":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["cta","email","organization_id","user_id"]},
          'user_invites_teammate': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"invite_location":{"type":"string"},"organization_id":{"type":"string"},"role":{"type":"string"},"seat_type":{"type":"string"},"teammate_email":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","invite_location","organization_id","seat_type","user_id"]},
          'user_launched_quick_account_mapping': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_id":{"type":"string"},"partner_population_id":{"type":"string"},"partner_segment":{"type":"string"},"population_id":{"type":"string"},"potential_influence_revenue":{"type":"number"},"qam_type":{"type":"string"},"records_returned":{"type":"integer"},"segment":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_id","partner_population_id","population_id","qam_type","user_id"]},
          'user_logged_in': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"source":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_opens_setup_guide': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_ran_report': {"type":"object","properties":{"default_column_names":{"items":{"type":"string"},"type":"array"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"filter_operators":{"type":"string"},"greenfield_type":{"type":"string"},"organization_id":{"type":"string"},"partner_filter_metadata":{"type":"object"},"partner_id":{"items":{"type":"number"},"type":"array"},"partner_impact_scores":{"items":{"type":"string"},"type":"array"},"partner_population_ids":{"items":{"type":"string"},"type":"array"},"partner_tag":{"items":{"type":"string"},"type":"array"},"pop_filter_metadata":{"items":{"type":"string"},"type":"array"},"population_id":{"items":{"type":"number"},"type":"array"},"records_returned":{"type":"integer"},"report_id":{"type":"string"},"report_name":{"type":"string"},"report_type":{"type":"string"},"shared_partner_id":{"type":"integer"},"source_field_ids":{"items":{"type":"string"},"type":"array"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_id","partner_population_ids","population_id","report_type","user_id"]},
          'user_redeems_invite': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"source":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","user_id"]},
          'user_registration_elg_summit': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"source":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","user_id"]},
          'user_removed_partner_mapping_rule': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"number"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"source_id":{"type":"number"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","feed_id","organization_id","source_id","user_id"]},
          'user_requested_access_to_beta_feature': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"source":{"type":"string"},"type":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","type"]},
          'user_requested_agent_trigger': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"prompt":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","prompt","user_id"]},
          'user_requested_data_share': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"partner_population_id":{"type":"string"},"reminder_nudge":{"type":"boolean"},"share_request_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","partner_population_id","share_request_id","user_id"]},
          'user_requested_free_trial': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"is_onboarded":{"type":"boolean"},"onboarding_stage":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","is_onboarded","organization_id","user_id"]},
          'user_requested_free_trial_contact': {"type":"object","properties":{"contact_type":{"type":"string"},"context":{"type":"object"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["contact_type","email","organization_id","user_id"]},
          'user_requested_seat': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"source":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","source","user_id"]},
          'user_reviews_billing_plan': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_saved_partner_mapping_rule': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"number"},"is_new":{"type":"boolean"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"rule_field":{"type":"string"},"rule_operator":{"type":"string"},"rule_value":{"type":"string"},"source_id":{"type":"number"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","feed_id","is_new","organization_id","rule_field","rule_operator","rule_value","source_id","user_id"]},
          'user_saves_copilot_integration_setting': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"integration_name":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","integration_name","organization_id","user_id"]},
          'user_searches': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"search_term":{"type":"string"},"user_id":{"type":"string"},"view":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_sends_records': {"type":"object","properties":{"action_name":{"type":"string"},"clicked_from":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"list_id":{"type":"string"},"list_name":{"type":"string"},"location":{"type":"string"},"number_of_records":{"type":"string"},"organization_id":{"type":"string"},"sent_to_user_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["action_name","clicked_from","email","list_name","location","number_of_records","organization_id","user_id"]},
          'user_sent_partner_invite': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"invite_message":{"type":"string"},"invite_type":{"type":"string"},"organization_id":{"type":"string"},"partner_organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_set_partner_mapping_manual_match': {"type":"object","properties":{"crm_account_id":{"type":"string"},"crm_type":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"number"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"partner_org_id":{"type":"string"},"source_id":{"type":"number"},"user_id":{"type":"string"},"was_previously_mapped":{"type":"boolean"}},"additionalProperties":false,"required":["crm_account_id","crm_type","email","feed_id","organization_id","source_id","user_id","was_previously_mapped"]},
          'user_shares_list_action': {"type":"object","properties":{"action":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"general_access":{"type":"string"},"organization_id":{"type":"string"},"report_id":{"type":"string"},"shared_with_user_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["action","email","organization_id","user_id"]},
          'user_toggled_partner_tags_sync': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"number"},"is_enabled":{"type":"boolean"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","feed_id","is_enabled","organization_id","user_id"]},
          'user_updated_list_records': {"type":"object","properties":{"action":{"type":"string"},"action_location":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"new_value":{"type":"string"},"organization_id":{"type":"string"},"previous_value":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["action_location","email","organization_id","previous_value","user_id"]},
          'user_updated_shared_list_access': {"type":"object","properties":{"access_type":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"impacted_user_email":{"type":"string"},"impacted_user_id":{"type":"string"},"list_action":{"type":"string"},"list_id":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","impacted_user_email","impacted_user_id","list_action","organization_id","user_id"]},
          'user_upgrades_to_connector': {"type":"object","properties":{"cta":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_upgrades_to_platform_connector': {"type":"object","properties":{"cta":{"type":"string"},"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"has_discount":{"type":"boolean"},"organization_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","organization_id","user_id"]},
          'user_viewed_partner_mapping_tab': {"type":"object","properties":{"device_id":{"type":"string"},"email":{"type":"string"},"event_site":{"type":"string"},"feed_id":{"type":"number"},"metadata":{"type":"object"},"organization_id":{"type":"string"},"source_id":{"type":"number"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["email","feed_id","organization_id","source_id","user_id"]},
        }),
        ...destinationPlugins,
        ...plugins,
      ]
    });
  }

  /**
   * Alias a user ID to another user ID.
   * @param {string} userId The user's new ID.
   * @param {string} previousId The user's previous ID.
   * @param {AliasOptions} [options] Options for this alias call.
   */
  alias(userId, previousId, options) {
    this.itly.alias(userId, previousId, options);
  }

  /**
   * Identify a user and set or update that user's properties.
   * @param {string} [userId] The user's ID.
   * @param {Object} properties The user's properties.
   * @param {string} properties.email Email address of the user
   * @param {IdentifyOptions} [options] Options for this identify call.
   */
  identify(userId, properties, options) {
    this.itly.identify(userId, properties, options);
  }

  /**
   * Associate the current user with a group and set or update that group's properties.
   * @param {string} groupId The group's ID.
   * @param {Object} [properties] The group's properties.
   * @param {string} [properties.name] The name of the an organization on Crossbeam
   * @param {GroupOptions} [options] Options for this group call.
   */
  group(groupId, properties, options) {
    this.itly.group(groupId, properties, options);
  }

  /**
   * Track a page view.
   * @param {string} category The page's category.
   * @param {string} name The page's name.
   * @param {PageOptions} [options] Options for this page call.
   */
  page(category, name, options) {
    this.itly.page(category, name, undefined, options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} properties.conversation_id Property has no description in tracking plan.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.source] The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  aiChatAction(properties, options) {
    this.itly.track(new AiChatAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action] This field will capture the following actions;  **Attribution**: Added / Removed  **Collaborate**: Edited List Name / Edited List Description / Edited Note **Updating List Records**: Added Records / Removed Records  **Autonomous Agents**: Created/Deleted/Edited/Template Clicked/Tested
   * @param {string[]} [properties.conditions] Array of strings; conditions an account, opportunity or partner must meet for it to cause an agent to fire
   * @param {string} properties.description Property has no description in tracking plan.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.instructions] Specific instructions for the agent to template messages properly
   * @param {string[]} [properties.notification_channel] Notification type; e.g. slack channels, emails
   * @param {string} [properties.notification_channel_type] Channel type: e.g. slack, email
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.trigger What triggers an autonomous agent to fire
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  autonomousAgentAction(properties, options) {
    this.itly.track(new AutonomousAgentAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  copilotAction(properties, options) {
    this.itly.track(new CopilotAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  copilotNavigation(properties, options) {
    this.itly.track(new CopilotNavigation(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  dataSharingAction(properties, options) {
    this.itly.track(new DataSharingAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  dealNavDrawerAction(properties, options) {
    this.itly.track(new DealNavDrawerAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  dealNavDrawerNavigation(properties, options) {
    this.itly.track(new DealNavDrawerNavigation(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  optOutIsActive(properties, options) {
    this.itly.track(new OptOutIsActive(properties), options);
  }

  /**
   * Fires alongside any qualifying activation-signal event. Used by Ops to see if an org has activated with a single event query rather than the multi-event union we use today.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.triggering_event Name of the source event that triggered the umbrella event.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  organizationActivated(properties, options) {
    this.itly.track(new OrganizationActivated(properties), options);
  }

  /**
   * This event represents a user interacting with the partner wishlist feature within the Crossbeam application. It is triggered whenever a user adds, removes, or modifies an entry in their partner wishlist.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action] This field will capture the following actions;  **Attribution**: Added / Removed  **Collaborate**: Edited List Name / Edited List Description / Edited Note **Updating List Records**: Added Records / Removed Records  **Autonomous Agents**: Created/Deleted/Edited/Template Clicked/Tested
   * @param {number} [properties.contact_count] Property has no description in tracking plan.
   * @param {string} [properties.decline_reason] Property has no description in tracking plan.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} properties.event_site This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {boolean} [properties.has_errors] Property has no description in tracking plan.
   * @param {boolean} [properties.has_message] Property has no description in tracking plan.
   * @param {number} [properties.invite_count] Property has no description in tracking plan.
   * @param {string} [properties.invite_option] Property has no description in tracking plan.
   * @param {boolean} [properties.is_on_crossbeam] Property has no description in tracking plan.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {number} [properties.on_crossbeam_count] Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {number} [properties.remove_count] Property has no description in tracking plan.
   * @param {number} [properties.total_partners] Property has no description in tracking plan.
   * @param {number} [properties.total_rows] Property has no description in tracking plan.
   * @param {string} properties.type The type of signup, e.g. invited, organic.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  partnerWishlistAction(properties, options) {
    this.itly.track(new PartnerWishlistAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {boolean} [properties.iframe] Whether or not this event occurred within an iframe - should be `true` or `false`
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  performanceDashboardAction(properties, options) {
    this.itly.track(new PerformanceDashboardAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {boolean} [properties.iframe] Whether or not this event occurred within an iframe - should be `true` or `false`
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  performanceDashboardNavigation(properties, options) {
    this.itly.track(new PerformanceDashboardNavigation(properties), options);
  }

  /**
   * Called when a user accepts an inbound partner invite
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.invite_type] Email, link, partner suggestion, etc.
   * @param {string} properties.organization_id The organization the user was logged into at the time
   * @param {string} properties.partner_organization_id The organization that sent the partner invite
   * @param {string} properties.proposal_id The corresponding proposal_id for the invite being accepted
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userAcceptedPartnerInvite(properties, options) {
    this.itly.track(new UserAcceptedPartnerInvite(properties), options);
  }

  /**
   * This event tracks when a user performs an action on the columns of a shared list
   * @param {Object} properties The event's properties.
   * @param {string} properties.column_action Property has no description in tracking plan.
   * @param {string} properties.column_name Property has no description in tracking plan.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.new_value] Property has no description in tracking plan.
   * @param {string} [properties.old_value] Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userActsOnListColumns(properties, options) {
    this.itly.track(new UserActsOnListColumns(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.mop Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userAddedMop(properties, options) {
    this.itly.track(new UserAddedMop(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} properties.account_id Property has no description in tracking plan.
   * @param {string} [properties.content] Property has no description in tracking plan.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userAddsListNote(properties, options) {
    this.itly.track(new UserAddsListNote(properties), options);
  }

  /**
   * This event captures the partners that were attributed for an opportunity.
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action] This field will capture the following actions;  **Attribution**: Added / Removed  **Collaborate**: Edited List Name / Edited List Description / Edited Note **Updating List Records**: Added Records / Removed Records  **Autonomous Agents**: Created/Deleted/Edited/Template Clicked/Tested
   * @param {string} properties.attribution_method This field will capture if the partner was added/removed through recommended partners or seached in the search bar.
   * @param {string} [properties.close_won_date] This field will capture the close won date for the attributed opportunity
   * @param {string} properties.deal_id This field will capture the unique deal_id for the opportunity.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.opportunity_account_name Thie field will capture the name of the opportunity account that is being attributed
   * @param {number} [properties.opportunity_amount] This field will capture the amount associated with the opportunity
   * @param {string} properties.opportunity_name Thie field will capture the name of the opportunity that is being attributed
   * @param {string} [properties.opportunity_stage] This field will capture if the attributed opportunity was open or closed won.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userAttributedPartners(properties, options) {
    this.itly.track(new UserAttributedPartners(properties), options);
  }

  /**
   * This event occurs when a user sets up or changes sharing rules, at any level.  It is only fired once, even if the rule affects multiple partners/populations (those are covered in array field properties).
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string[]} [properties.new_field_ids_shared] When a data sharing rule is updated, this field will capture the end state of source field ids that are shared with the partner.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string[]} [properties.partner_id] Property has no description in tracking plan.
   * @param {string[]} [properties.partner_population_id] Property has no description in tracking plan.
   * @param {string} properties.population_id The population ID of the user
   * @param {string} [properties.preset_type] The type of data preset selected when changing the data sharing rule:   * Account Map  * Co-Sell  * Customize Fields
   * @param {string[]} [properties.previous_field_ids_shared] Before a data sharing rule is updated, this field will capture the previous state of source field ids that were shared with the partner.
   * @param {string} [properties.previous_sharing_rule] The previous sharing level of the data share.
   * @param {string} properties.sharing_level What sharing level is this rule?  * Population  * Partner  * Partner Population
   * @param {string} properties.sharing_rule What rule was applied at the level?  * Hidden  * Overlap Counts Only  * Sharing Data  * greenfield_full
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userChangesSharingRules(properties, options) {
    this.itly.track(new UserChangesSharingRules(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.feed_id The feed the user created as a result
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {number} properties.source_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClearedPartnerMappingManualMatch(properties, options) {
    this.itly.track(new UserClearedPartnerMappingManualMatch(properties), options);
  }

  /**
   * Called in when a user clicks "Add Seats" CTA either from Billing page or Teams page.
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.location Location is the name of the page or where the action was launched from;  For exports, two options:  * `in_report`  * `ellipsis_out_report`  **For add seats, two options:**  * `billing_page`  * `teams_page`    **For Salesforce Widget, two options:**  * Starter Widget  * Widget Banner       \- For Shared List  * Collaborate  * Account Mapping
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedAddSeats(properties, options) {
    this.itly.track(new UserClickedAddSeats(properties), options);
  }

  /**
   * Called when a user clicks add/review attribution in attribution engine.
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} properties.attribution_source Thie field will capture if the click was for adding the attribution or reviewing the attribution.
   * @param {string} [properties.close_won_date] This field will capture the close won date for the attributed opportunity
   * @param {string} properties.deal_id This field will capture the unique deal_id for the opportunity.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.opportunity_account_name Thie field will capture the name of the opportunity account that is being attributed
   * @param {number} [properties.opportunity_amount] This field will capture the amount associated with the opportunity
   * @param {string} properties.opportunity_name Thie field will capture the name of the opportunity that is being attributed
   * @param {string} [properties.opportunity_stage] This field will capture if the attributed opportunity was open or closed won.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedAttribution(properties, options) {
    this.itly.track(new UserClickedAttribution(properties), options);
  }

  /**
   * This event tracks when and where a user clicks on the close-out action button
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} properties.close_out_location This field will capture if the close-out location was one of the following;   * carousel  * add_attribution  * review_attribution  * billing_step_1  * billing_step_2
   * @param {string} [properties.close_won_date] This field will capture the close won date for the attributed opportunity
   * @param {string} properties.deal_id This field will capture the unique deal_id for the opportunity.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.feature_name Thie field will capture the feature for which the action was taken; example;  * Attribution  * Shared List  * etc
   * @param {boolean} [properties.is_dismissed] This field will capture if the deal was dismissed in this close out action.
   * @param {string} properties.opportunity_account_name Thie field will capture the name of the opportunity account that is being attributed
   * @param {number} [properties.opportunity_amount] This field will capture the amount associated with the opportunity
   * @param {string} properties.opportunity_name Thie field will capture the name of the opportunity that is being attributed
   * @param {string} [properties.opportunity_stage] This field will capture if the attributed opportunity was open or closed won.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedCloseOutAction(properties, options) {
    this.itly.track(new UserClickedCloseOutAction(properties), options);
  }

  /**
   * Called when a user clicks one of the data source tiles on the data sources page - regardless of whether they actually connect or not.
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} properties.data_source_type The type of data source (ie, CSV, Google Sheets, HubSpot, Salesforce, etc.)
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedConnectDataSource(properties, options) {
    this.itly.track(new UserClickedConnectDataSource(properties), options);
  }

  /**
   * Event to track when a user clicks to create a new population within the platform
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.population_type] The type of population that was created;   * customer  * open_opportunity  * prospects  * custom
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedCreatePopulation(properties, options) {
    this.itly.track(new UserClickedCreatePopulation(properties), options);
  }

  /**
   * This event tracks when a user clicks on a link that directs them to Opportunity record in their Salesforce CRM
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.close_won_date] This field will capture the close won date for the attributed opportunity
   * @param {string} properties.crm_type This field will capture if the crm type as we will support multiple crm in the URL.  * Salesforce  * Hubspot  * Other
   * @param {string} properties.deal_id This field will capture the unique deal_id for the opportunity.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.opportunity_account_name Thie field will capture the name of the opportunity account that is being attributed
   * @param {number} [properties.opportunity_amount] This field will capture the amount associated with the opportunity
   * @param {string} properties.opportunity_name Thie field will capture the name of the opportunity that is being attributed
   * @param {string} [properties.opportunity_stage] This field will capture if the attributed opportunity was open or closed won.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedCrmLink(properties, options) {
    this.itly.track(new UserClickedCrmLink(properties), options);
  }

  /**
   * This event tracks when a user clicks on a data sharing preset such as account mapping, co-sell, or customize fields.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {string} [properties.preset_type] The type of data preset selected when changing the data sharing rule:   * Account Map  * Co-Sell  * Customize Fields
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedDataSharingPreset(properties, options) {
    this.itly.track(new UserClickedDataSharingPreset(properties), options);
  }

  /**
   * Called when a user clicks the `downgrade` button anywhere in the app
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedDowngrade(properties, options) {
    this.itly.track(new UserClickedDowngrade(properties), options);
  }

  /**
   * This event tracks when a user clicks on the edit/pencil button at specific places within the application.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.property_name This field will capture the name of the property user is trying to edit.   * Partner Name  * Population Name  * etc
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedEdit(properties, options) {
    this.itly.track(new UserClickedEdit(properties), options);
  }

  /**
   * This event tracks when a user clicks on filters to refine their search or view preferences in attribution
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.end_date] Property has no description in tracking plan.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.filter_location This field is to capture one of the location where the filter is being used.  * attribution_table_view  * Other
   * @param {string} properties.filter_name This field will be used to capture the name of the filter.     * Opportunity Stage (Open/Closed-Won)  * Date Range  * Amount Range
   * @param {number} [properties.max_amount_range] The maximum amount applied in the amount range field.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {number} [properties.min_amount_range] The minimum amount applied in the amount range field.
   * @param {string} [properties.opportunity_stage] This field will capture if the attributed opportunity was open or closed won.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.start_date] Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedFilters(properties, options) {
    this.itly.track(new UserClickedFilters(properties), options);
  }

  /**
   * Called if the user clicks any of the CTAs on one of the integrations tiles at https://app.crossbeam.com/integrations
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} properties.button_name The text of the CTA/button that was clicked, ie `View App`, `Install App`, or `Contact Us`
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.integration_name The name of the integration where the CTA was clicked
   * @param {string} properties.organization_id The organization the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedIntegrationCta(properties, options) {
    this.itly.track(new UserClickedIntegrationCta(properties), options);
  }

  /**
   * This event tracks when a user clicks to keep their current plan
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedKeepCurrentPlan(properties, options) {
    this.itly.track(new UserClickedKeepCurrentPlan(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedLearnMore(properties, options) {
    this.itly.track(new UserClickedLearnMore(properties), options);
  }

  /**
   * Called when a user clicks on a notification in the notification tray.
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.notification_text The text of the notification
   * @param {boolean} properties.notification_unread True if the notification was still marked as unread, false if not
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedNotification(properties, options) {
    this.itly.track(new UserClickedNotification(properties), options);
  }

  /**
   * This event tracks when a user clicks on the partner ecosystem tab
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_email Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedPartnerDirectory(properties, options) {
    this.itly.track(new UserClickedPartnerDirectory(properties), options);
  }

  /**
   * User can toggel between 'Total Overlaps' and 'Potential Influence'. So this event will track that behavior.
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {number} [properties.potential_revenue] The potential revenue in the summary
   * @param {string} properties.summary_type Either Total Overlaps or Potential Revenue
   * @param {number} [properties.total_overlaps] The number of total overlaps in the summary
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedPartnershipSummary(properties, options) {
    this.itly.track(new UserClickedPartnershipSummary(properties), options);
  }

  /**
   * Called when a user clicks "Pay Now" CTA in the billing flow.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.billing_cycle] This property will capture if the selected billing cycle was annually or monthly.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.full_seats Number of full seats purchased in the transaction.
   * @param {number} [properties.invoice_amount] This property will capture the amount that will be charged in the billing.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {number} properties.sales_seats Number of sales seats added in the transaction.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedPayNow(properties, options) {
    this.itly.track(new UserClickedPayNow(properties), options);
  }

  /**
   * This event tracks when a user clicks on the "Request Access" button in Salesforce Widget
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.location Location is the name of the page or where the action was launched from;  For exports, two options:  * `in_report`  * `ellipsis_out_report`  **For add seats, two options:**  * `billing_page`  * `teams_page`    **For Salesforce Widget, two options:**  * Starter Widget  * Widget Banner       \- For Shared List  * Collaborate  * Account Mapping
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_email Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedRequestAccess(properties, options) {
    this.itly.track(new UserClickedRequestAccess(properties), options);
  }

  /**
   * This event tracks when a user clicks on the "Restore Plan" button
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedRestorePlan(properties, options) {
    this.itly.track(new UserClickedRestorePlan(properties), options);
  }

  /**
   * Called when a user clicks the `review` button in step 2 of billing that leads to **Pay Now** page while upgrading to connector tier.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.billing_cycle] This property will capture if the selected billing cycle was annually or monthly.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} [properties.invoice_amount] This property will capture the amount that will be charged in the billing.
   * @param {number} properties.number_of_seats This property will capture the number of seats added in the billing.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedReview(properties, options) {
    this.itly.track(new UserClickedReview(properties), options);
  }

  /**
   * Called when a user clicks the See Overlaps button on the partners page
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.partner_id The ID of the partner
   * @param {number[]} properties.population_id A list of all population_ids used in this report
   * @param {number} [properties.records_returned] Number of records in the report.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedSeeOverlaps(properties, options) {
    this.itly.track(new UserClickedSeeOverlaps(properties), options);
  }

  /**
   * Called when a Salesforce user clicks the "Open in Crossbeam" button in the Salesforce app widget
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_email Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedSfApp(properties, options) {
    this.itly.track(new UserClickedSfApp(properties), options);
  }

  /**
   * This event tracks when a user clicks to sync data
   * @param {Object} properties The event's properties.
   * @param {string} [properties.cta_location] The page where the CTA was clicked
   * @param {string} properties.data_type Property has no description in tracking plan.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedSyncData(properties, options) {
    this.itly.track(new UserClickedSyncData(properties), options);
  }

  /**
   * Called when a user clicks the `upgrade` button on any page that leads to the Supernode tier
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.attribution_credits] Number of credits used when "Talk to Sales" CTA was clicked on attribution page.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {boolean} [properties.early_adopter_status] Denotes whether the organization was currently an early adopter at the time of the event
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedTalkToSalesSupernode(properties, options) {
    this.itly.track(new UserClickedTalkToSalesSupernode(properties), options);
  }

  /**
   * Called when a user clicks the Top Overlaps charts in the dashboard and partner specific page
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.partner_id The ID of the partner
   * @param {string} properties.partner_population_id The ID of the partner's population
   * @param {string} properties.population_id The ID of the user's population
   * @param {number} [properties.records_returned] Number of records in the report.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedTopOverlaps(properties, options) {
    this.itly.track(new UserClickedTopOverlaps(properties), options);
  }

  /**
   * Called when a user clicks a partner suggestion in the universal search bar
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id Property has no description in tracking plan.
   * @param {string} [properties.partner_id] Organization ID of the partner being suggested (may not always be available)
   * @param {string} properties.partner_url The url/domain of the suggested partner
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedUniversalSuggestedPartner(properties, options) {
    this.itly.track(new UserClickedUniversalSuggestedPartner(properties), options);
  }

  /**
   * Called when a user clicks the `upgrade` button on any page that leads to the Connector tier
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.billing_cycle] This property will capture if the selected billing cycle was annually or monthly.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {boolean} [properties.early_adopter_status] Denotes whether the organization was currently an early adopter at the time of the event
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} [properties.number_of_seats] Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} [properties.report_name] The name the user gave the report
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedUpgradeConnector(properties, options) {
    this.itly.track(new UserClickedUpgradeConnector(properties), options);
  }

  /**
   * Called when a user clicks the `upgrade` button on any page that leads to the Connector tier
   * @param {Object} properties The event's properties.
   * @param {string} [properties.billing_cycle] This property will capture if the selected billing cycle was annually or monthly.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {boolean} [properties.has_discount] Whether a discount was applied to waive the connector platform fee
   * @param {number} [properties.number_of_seats] Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClickedUpgradePlatformConnector(properties, options) {
    this.itly.track(new UserClickedUpgradePlatformConnector(properties), options);
  }

  /**
   * This event tracks when a user clicks "Add Offline Partner" in the Add Partner tab.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksAddOfflinePartner(properties, options) {
    this.itly.track(new UserClicksAddOfflinePartner(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action_name] The "thing" the user did within deal navigator  * sort usage  * opens account detail drawer  * clicks "view in CRM"  * etc.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksDealNavigator(properties, options) {
    this.itly.track(new UserClicksDealNavigator(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.object] Captures the type of object where the click happened.  * Plays  * Contacts  * Partners  * etc
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.overlap_company_domain] Captures the domain of the company where action happened
   * @param {string} [properties.overlap_company_name] Captures the name of the company where the action happened
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksGetIntelInCopilot(properties, options) {
    this.itly.track(new UserClicksGetIntelInCopilot(properties), options);
  }

  /**
   * This event is called when a user clicks on a refer lead PartnerStack CTA in reports or shared list.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.list_id] This property will capture List ID.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.refer_lead_location The user can click on refer lead CTA from two locations; shared list & reports
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksPartnerstackReferLead(properties, options) {
    this.itly.track(new UserClicksPartnerstackReferLead(properties), options);
  }

  /**
   * This event is called when a user clicks on a submit lead PartnerStack CTA in reports or shared list.
   * @param {Object} properties The event's properties.
   * @param {string} properties.company_name Name of the company added in the modal while submitting the lead to PartnerStack
   * @param {string} properties.contact_email Email of the contact added in the modal while submitting the lead to PartnerStack.
   * @param {string} properties.contact_first_name First name of the contact added in the modal while submitting the lead to PartnerStack
   * @param {string} properties.contact_last_name Last name of the contact added in the modal while submitting the lead to PartnerStack
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.list_id] This property will capture List ID.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.partnerstack_partner This property will capture the name of the partnerstack partner that is captured from the partnerstack database.
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} properties.submit_lead_location The user can click on submit lead CTA from two locations; shared list & reports
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksPartnerstackSubmitLead(properties, options) {
    this.itly.track(new UserClicksPartnerstackSubmitLead(properties), options);
  }

  /**
   * This event tracks when a user clicks the "send" button in shared list to submit a record.
   * @param {Object} properties The event's properties.
   * @param {string} properties.action_name The action name should exactly match with the text that user clicked when sending a record, for ex;   * Send to Account Executive  * Refer Leads to PartnerStack  * etc
   * @param {string} properties.clicked_from The records that are clicked to send will use either of the following;   * List Row   * Above List
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.list_id] This property will capture List ID.
   * @param {string} properties.list_name Name of the list.
   * @param {string} properties.location Location is the name of the page or where the action was launched from;  For exports, two options:  * `in_report`  * `ellipsis_out_report`  **For add seats, two options:**  * `billing_page`  * `teams_page`    **For Salesforce Widget, two options:**  * Starter Widget  * Widget Banner       \- For Shared List  * Collaborate  * Account Mapping
   * @param {string} properties.number_of_records Number of records that are selected in the send.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksSendRecords(properties, options) {
    this.itly.track(new UserClicksSendRecords(properties), options);
  }

  /**
   * Called when a user clicks any step or option within the setup guide
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.button_name] The text of the button/link/component the user clicked on
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id Property has no description in tracking plan.
   * @param {string} properties.setup_button_name Property has no description in tracking plan.
   * @param {string} properties.setup_step_name Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userClicksSetupGuide(properties, options) {
    this.itly.track(new UserClicksSetupGuide(properties), options);
  }

  /**
   * This event tracks when a user successfully completes the onboarding process aka setup guide.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userCompletesOnboarding(properties, options) {
    this.itly.track(new UserCompletesOnboarding(properties), options);
  }

  /**
   * Called when a user completes a data source connection
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string[]} [properties.custom_presets] If the data source was set up with custom field selections, were any of the data presets selected when they finalized selections?  If so, list them in this json field
   * @param {string} properties.data_source_type The type of data source (ie, CSV, Google Sheets, HubSpot, Salesforce, etc.)
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.feed_id The feed the user created as a result
   * @param {string} [properties.initial_sync_selection] What was the option the user selected when setting the sync up?  Currently three available:  * Required  * Recommended  * Custom  If the data source doesn't have these options, remain null
   * @param {string} properties.organization_id The organization the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userConnectedDataSource(properties, options) {
    this.itly.track(new UserConnectedDataSource(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action_type] Following are the actions that a user can copy data from:  * email  * message  * phone_number
   * @param {string} properties.copied_data This field will capture the data copied by the user in copilot.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.email_type] Captures if the copied email is one of the follows:  * Account Owner  * Account Contact
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.object] Captures the type of object where the click happened.  * Plays  * Contacts  * Partners  * etc
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string[]} properties.partner_names Name of the partners whose data (email, message, phone_number) has been copied.
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userCopiesDataInCopilot(properties, options) {
    this.itly.track(new UserCopiesDataInCopilot(properties), options);
  }

  /**
   * This event tracks when a user creates a new list
   * @param {Object} properties The event's properties.
   * @param {number} properties.collaborator_id Org ID of the partner with whom the user want to collaborate on the list.
   * @param {number} properties.collaborator_user_id ID of the user on partner side with whom the list is collaborated on.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.list_description Description of the list
   * @param {string} properties.list_name Name of the list.
   * @param {string} properties.location Location is the name of the page or where the action was launched from;  For exports, two options:  * `in_report`  * `ellipsis_out_report`  **For add seats, two options:**  * `billing_page`  * `teams_page`    **For Salesforce Widget, two options:**  * Starter Widget  * Widget Banner       \- For Shared List  * Collaborate  * Account Mapping
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userCreatedList(properties, options) {
    this.itly.track(new UserCreatedList(properties), options);
  }

  /**
   * Called when a user creates a new population
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization the user was logged into at the time
   * @param {string} properties.population_id The resulting population_id that got created
   * @param {string} properties.population_name The name of the population that was created
   * @param {string} [properties.population_type] The type of population that was created;   * customer  * open_opportunity  * prospects  * custom
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userCreatedPopulation(properties, options) {
    this.itly.track(new UserCreatedPopulation(properties), options);
  }

  /**
   * This event should be sent when a user saves a report using "Save" CTA in Account Mapping.
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.greenfield_type] This field will capture the following values only when the report type is greenfield.  * New accounts for you  * New accounts for your partner
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string[]} [properties.partner_impact_scores] This field will be used when user applies partner impact score filter in the report. Use can select `low`, `medium`, `high`, and `none`, and an empty array would mean the filter was not applied.
   * @param {number} [properties.records_returned] Number of records in the report.
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} properties.report_type This field will capture the type of the report.  * `single-partner-overlaps`  * `single-partner-oppty` (potential revenue)  * `single-partner-greenfield`  * `standard` (ecosystem / all partners standard)  * `partner-tags`  * `custom`
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userCreatedReport(properties, options) {
    this.itly.track(new UserCreatedReport(properties), options);
  }

  /**
   * Tracks when a user customizes settings to share specific data with partners or collaborators, indicating preferences for data visibility and access. Event to be pushed on first time definitions and on updates.
   * @param {Object} properties The event's properties.
   * @param {boolean} [properties.bulk] Property has no description in tracking plan.
   * @param {string[]} [properties.changed] shows the things about the data sharing that were changed
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_id] Partner ID on the data sharing change
   * @param {string[]} [properties.partner_population_id] The ID of the partner's population
   * @param {string} properties.population_id A list of all population_ids used in this report
   * @param {string} [properties.population_type] The type of population that was created;   * customer  * open_opportunity  * prospects  * custom
   * @param {string} [properties.preset_type] this is currently passing whether it's the recommended type, or another preset!
   * @param {string} [properties.previous_sharing_level] The previous sharing level in case of updates to sharing settings. passed as null if this is the first time definition and as the current sharing level in case another property (like visibility level) is changed, but the sharing level isn't.
   * @param {string} [properties.previous_visibility_level] The previous visibility level in case of updates to sharing settings. passed as null if this is the first time definition and as the current sharing level in case another property (like sharing level) is changed, but the visibility isn't.
   * @param {string[]} [properties.shared_fields] Property has no description in tracking plan.
   * @param {string} properties.sharing_level What sharing level is this rule?  * Population  * Partner  * Partner Population
   * @param {string} properties.source the data sharing event could have three sources:  * onboarding  * population  * partner  * default sharing
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {string} properties.visibility_level What visibility rule was applied at the level?  * Hidden  * Overlap Counts Only  * Sharing Data  * greenfield_full
   * @param {TrackOptions} [options] Options for this track call.
   */
  userDefinedDataSharing(properties, options) {
    this.itly.track(new UserDefinedDataSharing(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.preset_type] The type of data preset selected when changing the data sharing rule:   * Account Map  * Co-Sell  * Customize Fields
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userDefinedSharingPreset(properties, options) {
    this.itly.track(new UserDefinedSharingPreset(properties), options);
  }

  /**
   * This event tracks when a user edits a list such as list name, list description, notes, etc.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action] This field will capture the following actions;  **Attribution**: Added / Removed  **Collaborate**: Edited List Name / Edited List Description / Edited Note **Updating List Records**: Added Records / Removed Records  **Autonomous Agents**: Created/Deleted/Edited/Template Clicked/Tested
   * @param {string} [properties.column_id] The id of column when a column is updated in a list.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.list_id] This property will capture List ID.
   * @param {string} [properties.new_value] Property has no description in tracking plan.
   * @param {string} [properties.note_type] This property will capture if the note was added for the first time or edited later.    Note added for First time: Type = New   Note edited Later: Type = Updated
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.previous_value Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userEditedList(properties, options) {
    this.itly.track(new UserEditedList(properties), options);
  }

  /**
   * This event should be sent when a user clicks the Export CSV CTA on the setting page.
   *
   * Owner: sheda@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.end_date] Property has no description in tracking plan.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {number} [properties.records_exported] The number of records that were exported - this is only optional becuase exports launched from the ellipsis outside of a report cannot access record number.  All other exports should have this.
   * @param {string} [properties.start_date] Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userExportedAuditlog(properties, options) {
    this.itly.track(new UserExportedAuditlog(properties), options);
  }

  /**
   * This event should be sent when a user exports a report
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string[]} [properties.default_column_names] This field will capture default "crossbeam columns" because the data we provide in these report columns is not associated with any specific org.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.greenfield_type] This field will capture the following values only when the report type is greenfield.  * New accounts for you  * New accounts for your partner
   * @param {string} properties.location Location is the name of the page or where the action was launched from;  For exports, two options:  * `in_report`  * `ellipsis_out_report`  **For add seats, two options:**  * `billing_page`  * `teams_page`    **For Salesforce Widget, two options:**  * Starter Widget  * Widget Banner       \- For Shared List  * Collaborate  * Account Mapping
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {number[]} properties.partner_id A list of all the partner IDs included in this report
   * @param {string[]} [properties.partner_impact_scores] This field will be used when user applies partner impact score filter in the report. Use can select `low`, `medium`, `high`, and `none`, and an empty array would mean the filter was not applied.
   * @param {number[]} properties.population_id A list of all population_ids used in this report
   * @param {number} [properties.records_exported] The number of records that were exported - this is only optional becuase exports launched from the ellipsis outside of a report cannot access record number.  All other exports should have this.
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} [properties.report_name] The name the user gave the report
   * @param {string} properties.report_type This field will capture the type of the report.  * `single-partner-overlaps`  * `single-partner-oppty` (potential revenue)  * `single-partner-greenfield`  * `standard` (ecosystem / all partners standard)  * `partner-tags`  * `custom`
   * @param {string[]} [properties.source_field_ids] This field will capture the source field ids that are used in the report.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userExportedReport(properties, options) {
    this.itly.track(new UserExportedReport(properties), options);
  }

  /**
   * Called when a user ignores/hides a partner suggestion on the dashboard or partners page
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id Property has no description in tracking plan.
   * @param {string} [properties.partner_id] The organization_id of the suggested partner (may not always be available)
   * @param {string} properties.partner_url The url/domain of the suggested partner
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userIgnoredSuggestedPartner(properties, options) {
    this.itly.track(new UserIgnoredSuggestedPartner(properties), options);
  }

  /**
   * Triggered when a user interacts with the IRP component in Crossbeam, such as opening it, selecting an option, or taking an available action.
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {string} [properties.tab] Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userInteractedWithIrp(properties, options) {
    this.itly.track(new UserInteractedWithIrp(properties), options);
  }

  /**
   * This event tracks when a user interacts with the activity timeline feature in attribution.
   * @param {Object} properties The event's properties.
   * @param {string} properties.cta What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.cta_2] The secondary reason for clicking the CTA? If there is any!
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  userInteractedWithTimeline(properties, options) {
    this.itly.track(new UserInteractedWithTimeline(properties), options);
  }

  /**
   * Called when a user sends an invite to a teammate to join their Crossbeam organizations
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.invite_location This field will capture if the invite was sent from setup guide or team page.
   * @param {string} properties.organization_id The organization the user was logged into at the time
   * @param {string} [properties.role] The permission group for this user in this account.
   * @param {string} properties.seat_type This field will capture if the invited user seat was for core, sales edge viewer, coseller, reply_only.
   * @param {string} [properties.teammate_email] The email of the invited user
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userInvitesTeammate(properties, options) {
    this.itly.track(new UserInvitesTeammate(properties), options);
  }

  /**
   * Called when a user launches a report from the quick account mapping matrix
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.partner_id The ID of the partner
   * @param {string} properties.partner_population_id The population ID of the partner
   * @param {string} [properties.partner_segment] Property has no description in tracking plan.
   * @param {string} properties.population_id The population ID of the user
   * @param {number} [properties.potential_influence_revenue] The amount of influence revenue generated from the overlaps in the report.
   * @param {string} properties.qam_type What is the view type when the matrix was clicked:  * Total Overlaps  * Potential Influence Revenue
   * @param {number} [properties.records_returned] Number of records in the report.
   * @param {string} [properties.segment] Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userLaunchedQuickAccountMapping(properties, options) {
    this.itly.track(new UserLaunchedQuickAccountMapping(properties), options);
  }

  /**
   * Called when a user logs in to the app or starts a new session
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization the user logged into
   * @param {string} [properties.source] The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userLoggedIn(properties, options) {
    this.itly.track(new UserLoggedIn(properties), options);
  }

  /**
   * Called when a user opens the setup guide available in onboarding
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userOpensSetupGuide(properties, options) {
    this.itly.track(new UserOpensSetupGuide(properties), options);
  }

  /**
   * This event should be triggered when a user clicks on create report button or re-runs an existing report.
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string[]} [properties.default_column_names] This field will capture default "crossbeam columns" because the data we provide in these report columns is not associated with any specific org.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.filter_operators] This field
   * @param {string} [properties.greenfield_type] This field will capture the following values only when the report type is greenfield.  * New accounts for you  * New accounts for your partner
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {Object} [properties.partner_filter_metadata] Property has no description in tracking plan.
   * @param {number[]} properties.partner_id A list of all the partner IDs included in this report
   * @param {string[]} [properties.partner_impact_scores] This field will be used when user applies partner impact score filter in the report. Use can select `low`, `medium`, `high`, and `none`, and an empty array would mean the filter was not applied.
   * @param {string[]} properties.partner_population_ids This field will capture all the partner populations IDs that actually get returned when the report is run - not necessarily what the populations chosen were
   * @param {string[]} [properties.partner_tag] This field will capture the partner population tag used to create the following reports;  * Partner Tag  * Ecosystem  * Custom
   * @param {string[]} [properties.pop_filter_metadata] Property has no description in tracking plan.
   * @param {number[]} properties.population_id A list of all population_ids used in this report
   * @param {number} [properties.records_returned] Number of records in the report.
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} [properties.report_name] The name the user gave the report
   * @param {string} properties.report_type This field will capture the type of the report.  * `single-partner-overlaps`  * `single-partner-oppty` (potential revenue)  * `single-partner-greenfield`  * `standard` (ecosystem / all partners standard)  * `partner-tags`  * `custom`
   * @param {number} [properties.shared_partner_id] Externally Shared List Partner Org Id
   * @param {string[]} [properties.source_field_ids] This field will capture the source field ids that are used in the report.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRanReport(properties, options) {
    this.itly.track(new UserRanReport(properties), options);
  }

  /**
   * Event indicating when a user accepts an invitation to join a crossbeam.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRedeemsInvite(properties, options) {
    this.itly.track(new UserRedeemsInvite(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRegistrationElgSummit(properties, options) {
    this.itly.track(new UserRegistrationElgSummit(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.feed_id The feed the user created as a result
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {number} properties.source_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRemovedPartnerMappingRule(properties, options) {
    this.itly.track(new UserRemovedPartnerMappingRule(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.source The source where the action has happened;  * Salesforce  * HubSpot  * Chrome Extension  * etc
   * @param {string} properties.type What was the specific action/event that occurred?  Examples:  * `clicks_partner_tab`  * `clicks_account_tab`  * `clicks_generate_ai_playbook`  * `search`  * `sort`  * etc.
   * @param {string} [properties.user_id] Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRequestedAccessToBetaFeature(properties, options) {
    this.itly.track(new UserRequestedAccessToBetaFeature(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.prompt Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRequestedAgentTrigger(properties, options) {
    this.itly.track(new UserRequestedAgentTrigger(properties), options);
  }

  /**
   * This event tracks when a user clicks on "Request Data" on any population from their partner.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {string} properties.partner_population_id The ID of the partner's population
   * @param {boolean} [properties.reminder_nudge] This field will identify whether a share request is a reminder nudge - TRUE if it is, FALSE if it is net new.
   * @param {string} properties.share_request_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRequestedDataShare(properties, options) {
    this.itly.track(new UserRequestedDataShare(properties), options);
  }

  /**
   * Event indicating when a user has requested a free trial of connector. Resulting modal will depend on whether the user has completed onboarding or not.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {boolean} properties.is_onboarded Details on whether the user has completed the onboarding or not.    is_onboarded = true/false
   * @param {string} [properties.onboarding_stage] Indicating what the latest onboarding stage is.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRequestedFreeTrial(properties, options) {
    this.itly.track(new UserRequestedFreeTrial(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} properties.contact_type Chillipiper or Contact me button?
   * @param {Object} [properties.context] All additional context regarding the chilipiper request if any, like time and date, AE if any etc
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRequestedFreeTrialContact(properties, options) {
    this.itly.track(new UserRequestedFreeTrialContact(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.source * Seat invite  * General request
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userRequestedSeat(properties, options) {
    this.itly.track(new UserRequestedSeat(properties), options);
  }

  /**
   * Event tracking when a user reviews their billing plan details
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userReviewsBillingPlan(properties, options) {
    this.itly.track(new UserReviewsBillingPlan(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.feed_id The feed the user created as a result
   * @param {boolean} properties.is_new Property has no description in tracking plan.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.rule_field Property has no description in tracking plan.
   * @param {string} properties.rule_operator Property has no description in tracking plan.
   * @param {string} properties.rule_value Property has no description in tracking plan.
   * @param {number} properties.source_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSavedPartnerMappingRule(properties, options) {
    this.itly.track(new UserSavedPartnerMappingRule(properties), options);
  }

  /**
   * Event to track when a user saves their Copilot integration setting
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.integration_name The name of the integration where the CTA was clicked
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSavesCopilotIntegrationSetting(properties, options) {
    this.itly.track(new UserSavesCopilotIntegrationSetting(properties), options);
  }

  /**
   * This event should be triggered when a user clicks on create report button or re-runs an existing report.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.search_term] Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {string} [properties.view] close_deals or gen_pipe or (performance where needed)
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSearches(properties, options) {
    this.itly.track(new UserSearches(properties), options);
  }

  /**
   * This event tracks when a user sends records through shared list
   * @param {Object} properties The event's properties.
   * @param {string} properties.action_name The action name should exactly match with the text that user clicked when sending a record, for ex;   * Send to Account Executive  * Refer Leads to PartnerStack  * etc
   * @param {string} properties.clicked_from The records that are clicked to send will use either of the following;   * List Row   * Above List
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.list_id] This property will capture List ID.
   * @param {string} properties.list_name Name of the list.
   * @param {string} properties.location Location is the name of the page or where the action was launched from;  For exports, two options:  * `in_report`  * `ellipsis_out_report`  **For add seats, two options:**  * `billing_page`  * `teams_page`    **For Salesforce Widget, two options:**  * Starter Widget  * Widget Banner       \- For Shared List  * Collaborate  * Account Mapping
   * @param {string} properties.number_of_records Number of records that are selected in the send.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.sent_to_user_id] User ID of the user that received the records.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSendsRecords(properties, options) {
    this.itly.track(new UserSendsRecords(properties), options);
  }

  /**
   * Called when a user sends a partner invite
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.invite_message] Property has no description in tracking plan.
   * @param {string} [properties.invite_type] Email, link, partner suggestion etc.
   * @param {string} properties.organization_id The organization the user was logged into at the time
   * @param {string} [properties.partner_organization_id] The organization id for the partner (if it exists)
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSentPartnerInvite(properties, options) {
    this.itly.track(new UserSentPartnerInvite(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} properties.crm_account_id Property has no description in tracking plan.
   * @param {string} properties.crm_type This field will capture if the crm type as we will support multiple crm in the URL.  * Salesforce  * Hubspot  * Other
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.feed_id The feed the user created as a result
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.partner_org_id] The organization id for the partner
   * @param {number} properties.source_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {boolean} properties.was_previously_mapped Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSetPartnerMappingManualMatch(properties, options) {
    this.itly.track(new UserSetPartnerMappingManualMatch(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} properties.action shared_list or copied_link
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.general_access] Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} [properties.report_id] The ID of the report (if saved)
   * @param {string} [properties.shared_with_user_id] Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userSharesListAction(properties, options) {
    this.itly.track(new UserSharesListAction(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.feed_id The feed the user created as a result
   * @param {boolean} properties.is_enabled Property has no description in tracking plan.
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userToggledPartnerTagsSync(properties, options) {
    this.itly.track(new UserToggledPartnerTagsSync(properties), options);
  }

  /**
   * This event tracks when a user adds or deletes the records in a list
   * @param {Object} properties The event's properties.
   * @param {string} [properties.action] This field will capture the following actions;  **Attribution**: Added / Removed  **Collaborate**: Edited List Name / Edited List Description / Edited Note **Updating List Records**: Added Records / Removed Records  **Autonomous Agents**: Created/Deleted/Edited/Template Clicked/Tested
   * @param {string} properties.action_location The location of the action where the list is updated.   Reports   IRP
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} [properties.new_value] Property has no description in tracking plan.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.previous_value Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userUpdatedListRecords(properties, options) {
    this.itly.track(new UserUpdatedListRecords(properties), options);
  }

  /**
   * This event is called when a user creates/updates access to a shared list for other users.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.access_type] Called when a user changes the access type in shared list for other user.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.impacted_user_email This property will capture the imapcted user email who was either added, removed, or had a new permission access.
   * @param {string} properties.impacted_user_id This property will capture the imapcted user id who was either added, removed, or had a new permission access.
   * @param {string} properties.list_action This field will be capturing the type of user access action taken by the user for any list;   added   removed   updated access
   * @param {string} [properties.list_id] This property will capture List ID.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userUpdatedSharedListAccess(properties, options) {
    this.itly.track(new UserUpdatedSharedListAccess(properties), options);
  }

  /**
   * Called when a user completes the upgrade process to Connector tier through self-serve
   *
   * Owner: matt@crossbeam.com
   * @param {Object} properties The event's properties.
   * @param {string} [properties.cta] What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userUpgradesToConnector(properties, options) {
    this.itly.track(new UserUpgradesToConnector(properties), options);
  }

  /**
   * Called when a user completes the upgrade process to Connector tier through self-serve
   * @param {Object} properties The event's properties.
   * @param {string} [properties.cta] What was the reason for clicking, or the exact text in the button?  Examples:  * Billing  * SSO  * Additional Users  * Custom Roles  * Partner Cloud Integrations  * Create Population  * View Partner  * Share Data  * Sales Edge seats  **For Pay Now:**  * Upgrade to Crossbeam Connector  * Purchase Core Seats  * Purchase Sales Edge Seats  **For Add Seats:**  * Core Users  * Sales Edge Users  * Sales Edge Viewers  * Sales Edge Co-sellers  **For Account Mapping:**  * Saved Reports  * Pipeline  * Greenfield  * Ecosystem  * Partner Tag  * Custom  **For Salesforce Widget:**  * Starter Widget  * Widget Modal  * Widget Banner       **For Talk To Sales:**  * Attribution  * Account Mapping
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {boolean} [properties.has_discount] Whether a discount was applied to waive the connector platform fee
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userUpgradesToPlatformConnector(properties, options) {
    this.itly.track(new UserUpgradesToPlatformConnector(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param {Object} properties The event's properties.
   * @param {string} [properties.device_id] This is the unique device ID associated with the user at the time of action - this is the same as the device ID being utilized in LaunchDarkly.
   * @param {string} properties.email The email of the user.
   * @param {string} [properties.event_site] This property will capture the name of the CTA/action in the UI which will be unique per action.
   * @param {number} properties.feed_id The feed the user created as a result
   * @param {Object} [properties.metadata] A catch all for any additional things we want to know about an event - ie, what was the search term?  what was clicked, what were the tags on the item clicked?, etc.
   * @param {string} properties.organization_id The organization ID the user was logged into at the time
   * @param {number} properties.source_id Property has no description in tracking plan.
   * @param {string} properties.user_id Property has no description in tracking plan.
   * @param {TrackOptions} [options] Options for this track call.
   */
  userViewedPartnerMappingTab(properties, options) {
    this.itly.track(new UserViewedPartnerMappingTab(properties), options);
  }

  /**
   * Track any event.
   * @param {Object} event The event.
   * @param {string} event.name The event's name.
   * @param {string} [event.properties] The event's properties.
   * @param {string} [event.id] The event's ID.
   * @param {string} [event.version] The event's version.
   * @param {TrackOptions} [options] Options for this track call.
   */
  track(event, options) {
    this.itly.track(event, options);
  }

  /**
   * Reset (e.g. on logout) all analytics state for the current user and group.
   */
  reset() {
    this.itly.reset();
  }

  flush() {
    return this.itly.flush();
  }
}

const itlySdk = new Itly();

export default itlySdk;
export { AiChatAction, AutonomousAgentAction, CopilotAction, CopilotNavigation, DataSharingAction, DealNavDrawerAction, DealNavDrawerNavigation, OptOutIsActive, OrganizationActivated, PartnerWishlistAction, PerformanceDashboardAction, PerformanceDashboardNavigation, UserAcceptedPartnerInvite, UserActsOnListColumns, UserAddedMop, UserAddsListNote, UserAttributedPartners, UserChangesSharingRules, UserClearedPartnerMappingManualMatch, UserClickedAddSeats, UserClickedAttribution, UserClickedCloseOutAction, UserClickedConnectDataSource, UserClickedCreatePopulation, UserClickedCrmLink, UserClickedDataSharingPreset, UserClickedDowngrade, UserClickedEdit, UserClickedFilters, UserClickedIntegrationCta, UserClickedKeepCurrentPlan, UserClickedLearnMore, UserClickedNotification, UserClickedPartnerDirectory, UserClickedPartnershipSummary, UserClickedPayNow, UserClickedRequestAccess, UserClickedRestorePlan, UserClickedReview, UserClickedSeeOverlaps, UserClickedSfApp, UserClickedSyncData, UserClickedTalkToSalesSupernode, UserClickedTopOverlaps, UserClickedUniversalSuggestedPartner, UserClickedUpgradeConnector, UserClickedUpgradePlatformConnector, UserClicksAddOfflinePartner, UserClicksDealNavigator, UserClicksGetIntelInCopilot, UserClicksPartnerstackReferLead, UserClicksPartnerstackSubmitLead, UserClicksSendRecords, UserClicksSetupGuide, UserCompletesOnboarding, UserConnectedDataSource, UserCopiesDataInCopilot, UserCreatedList, UserCreatedPopulation, UserCreatedReport, UserDefinedDataSharing, UserDefinedSharingPreset, UserEditedList, UserExportedAuditlog, UserExportedReport, UserIgnoredSuggestedPartner, UserInteractedWithIrp, UserInteractedWithTimeline, UserInvitesTeammate, UserLaunchedQuickAccountMapping, UserLoggedIn, UserOpensSetupGuide, UserRanReport, UserRedeemsInvite, UserRegistrationElgSummit, UserRemovedPartnerMappingRule, UserRequestedAccessToBetaFeature, UserRequestedAgentTrigger, UserRequestedDataShare, UserRequestedFreeTrial, UserRequestedFreeTrialContact, UserRequestedSeat, UserReviewsBillingPlan, UserSavedPartnerMappingRule, UserSavesCopilotIntegrationSetting, UserSearches, UserSendsRecords, UserSentPartnerInvite, UserSetPartnerMappingManualMatch, UserSharesListAction, UserToggledPartnerTagsSync, UserUpdatedListRecords, UserUpdatedSharedListAccess, UserUpgradesToConnector, UserUpgradesToPlatformConnector, UserViewedPartnerMappingTab };
